﻿import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {Observable} from "rxjs";
import {Group} from "./group.interface";

@Injectable()
export class GroupsService {
    result: Object;
    error: Object;
    token: string;
    user_id: string;
    password: string;
    
    constructor(public http: HttpClient) {
    this.token = localStorage.getItem('token');
    this.password = localStorage.getItem('password');
    this.user_id = localStorage.getItem('user_id');
    }
    //note jw: http service in Angular 2.0 is using Observables not promises
    getGroups():Observable<Group[]> {
        let authToken = this.token + ':' + this.password;
        const authOptions = {headers: new HttpHeaders({'Authorization': 'Bearer ' + authToken})};
        return this.http.get<Group[]>('/api/groups/', authOptions)
    }

}